/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import { useRefresh, useUpdate, Toolbar, useGetOne, CreateButton, CardActions, useGetList, useCreate, usePermissions } from 'react-admin';
import Button from '@material-ui/core/Button';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import TextField from '@material-ui/core/TextField';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import { useHistory } from "react-router-dom";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog } from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
import ListAddStudents from '../components/ListAddStudents'
import Autocomplete from '@material-ui/lab/Autocomplete';
import Box from '@material-ui/core/Box';
import {
    KeyboardDatePicker,
} from '@material-ui/pickers';
import moment from 'moment';
import ListPayments from './ListPayments'
import TrainingTable from './TableStudentTraining'
import { toast } from 'react-toastify';
import { userContext } from '../context/Context'

export const ActionsList = props => (
    <CardActions>
        <CreateButton basePath={'/trainings'} />
    </CardActions>
);

export const ActionsSave = props => (
    <Toolbar {...props} >
        { /* <SaveButton disabled={props.pristine ? true : false} /> */}
        <CardActions />
    </Toolbar>
);

export const AddStudent = (props) => {

    const [openDialog, setOpenDialog] = React.useState()
    const { data } = useGetList(
        'students',
        { page: 1, perPage: 1000 },
        { field: 'id', order: 'DESC' },
        { active: true, scheduled_contains: props.formData.location }
    );
    return (<>
        <Dialog open={openDialog} fullWidth>

            {data && <ListAddStudents data={data} setOpenDialog={setOpenDialog} training={props.formData} />}

        </Dialog>
        <Button variant="contained" color="primary" disabled={props.isLogged ? false : true} onClick={() => setOpenDialog(true)
        }>
            Add
</Button>
    </>)

}


export const AssignButton = (props) => {

    const [userMe] = React.useContext(userContext)

    React.useEffect(() => {
        if (props && props.record && props.record.coaches) {
            props.record.coaches.forEach(coach => {
                if (coach.id === userMe.id) {
                    return props.setIsLogged(true)
                }
            })

        }


    }, [])

    const refresh = useRefresh();
    const data = { coaches: [...props && props.record && props.record.coaches && props.record.coaches, userMe && { id: userMe.id, username: userMe.username }] }
    const [update] = useUpdate('trainings', props && props.record && props.record.id && props.record.id, data, props && props.record && props.record);

    return (<>
        <Button variant="contained" color="primary" disabled={props.isLogged ? true : false} onClick={() => {
            if (props.isLogged !== true) {
                update()
                refresh()
                props.setIsLogged(true)
            }
        }}>
            Assign me
</Button>
    </>)
}

export const SaveButtonNotes = (props) => {

    const data = {
        Notes: props.formData.Notes
    }

    const [update] = useUpdate('trainings', props.formData.id, data, props.formData);

    return <Button variant="contained" color="primary"
        onClick={() => props.setNoteDialog(false) & update()}
    >
        Save
    </Button>
}

const useStyles = makeStyles({
    notification: {
        color: 'red'
    }
});

export const ProfileButton = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    let history = useHistory();
    const classes = useStyles();
    const [studentNoteDialog, setStudentNoteDialog] = React.useState(false)
    const { data } = useGetOne('students', props.student.id);
    const [value, setValue] = React.useState(null)
    const newNote = {
        note: value
    }
    const [update] = useUpdate('students', props.student.id, newNote, props.student);
    const refresh = useRefresh()

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    React.useEffect(() => {
        data && setValue(data.note)
    }, [data])

    return (
        <>
            <IconButton edge="end" aria-label="delete" onClick={handleClick}>
                {props.student.note ? <Badge badgeContent={'N'} color="error">
                    <PermContactCalendarIcon />
                </Badge>
                    : <PermContactCalendarIcon />
                }
            </IconButton>

            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={() => history.push(`/students/${props.student.id}`)}>Profile</MenuItem>
                <MenuItem className={props.student.note ? classes.notification : null} onClick={() => setStudentNoteDialog(true) & handleClose()} >Note</MenuItem>
            </Menu>
            <Dialog open={studentNoteDialog} fullWidth>

                <TextField style={{ margin: '10px' }} onChange={(e => setValue(e.target.value))} value={value} id="filled-basic" label="Student note" variant="filled" multiline />
                <Box display='flex' justifyContent='end' style={{ margin: '10px' }}>
                    <Button variant="contained" color="primary" onClick={() => update() & refresh()}>
                        Save
        </Button>
                    <Button style={{ marginLeft: '20px' }} variant="contained" color="primary" onClick={() => setStudentNoteDialog(false)}>
                        Close
    </Button>
                </Box>
            </Dialog>
        </>
    );
}

export const DeleteStudentButton = (props) => {

    const deleteStudent = props.training && props.training.students && props.training.students.map(x => x && x.id !== props.student.id && x)

    const data = {
        students: deleteStudent
    }

    const [update] = useUpdate('trainings', props.training && props.training.id, data, props.training && props.training);
    const refresh = useRefresh();

    return (<IconButton edge="end" aria-label="delete" onClick={() => update() & refresh()}>
        <DeleteIcon />
    </IconButton>)
}

export const PayButton = (props) => {
    const options = ['800', '1500', '2500', '4000'];
    const [studentPayDialog, setStudentPayDialog] = React.useState(false)
    const [autoCompleteinputValue, setAutoCompleteInputValue] = React.useState('');
    const [startDate, handleStartDateChange] = React.useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [endDate, handleEndDateChange] = React.useState();
    const [values, setValues] = React.useState({
        amount: '',
        fiscalNumber: null,
        //    year: '2020',
        //   month: '12',
    })
    const [autoCV, setAutoCV] = React.useState('4000')
    const [userMe] = React.useContext(userContext)

    React.useEffect(() => {
        if (autoCompleteinputValue === '800') {
            return handleEndDateChange(startDate)
        }
        handleEndDateChange(moment(startDate).add(1, 'months').format("YYYY-MM-DD"))
    }, [startDate])

    React.useEffect(() => {
        studentPayDialog && props.student.note && toast.info('Note: ' + props.student.note, {
            position: "bottom-right",
            autoClose: false,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            toastId: props.student.id
        })
    }, [studentPayDialog])

    const dataPayment = {
        amount: autoCompleteinputValue,
        // month: values && parseInt(values.month), 
        // year: values && parseInt(values.year),
        fiscalNumber: values.fiscalNumber,
        description: values && `${props.student.firstName + ' ' + props.student.lastName} payed ${autoCompleteinputValue}`,
        student: props.student.id,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
        coach: userMe && userMe.id
    }

    const [createPayment] = useCreate('payments', dataPayment);

    const refresh = useRefresh();
    const { permissions } = usePermissions();

    return (<>
        {props.button === true ? <Button style={{ marginBottom: '30px' }} variant="contained" color="primary" onClick={() => setStudentPayDialog(true)} >
            Payments
                </Button> : <IconButton edge="end" aria-label="delete" onClick={() => setStudentPayDialog(true)}>
            <MonetizationOnIcon />
        </IconButton>}
        <Dialog open={studentPayDialog} fullWidth>
            <Box style={{ margin: '10px' }}>
                <Box style={{ display: 'flex' }}>
                    <Autocomplete
                        id="controllable-states-demo"
                        inputValue={autoCompleteinputValue}
                        value={autoCV}
                        onChange={(event, newValue) => {
                            setAutoCV(newValue)
                        }}
                        onInputChange={(event, newInputValue) => {
                            if (newInputValue === '800') {
                                handleStartDateChange(moment().format("YYYY-MM-DD"))
                                handleEndDateChange(moment().format("YYYY-MM-DD"))
                            } else handleEndDateChange(moment(startDate).add(1, 'months').format("YYYY-MM-DD"))
                            setAutoCompleteInputValue(newInputValue);
                        }}
                        freeSolo={true}
                        options={options}
                        style={{ width: 300 }}
                        renderInput={(params) => <TextField {...params} label="Amount" variant="filled" />}
                    />
                    {permissions === 'SuperAdmin' && <TextField fullWidth style={{ paddingLeft: 10 }} onChange={e => setValues(x => ({ ...x, fiscalNumber: e.target.value }))} value={values.month} id="filled-basic" label="Fiscal number" variant="filled" />}
                </Box>
                <Box display='flex' flexDirection='column'>
                    <KeyboardDatePicker style={{ marginTop: '10px' }} format="DD/MM/yyyy" value={startDate} label="Start date" onChange={handleStartDateChange} inputVariant="filled" margin="dense" />
                    <KeyboardDatePicker style={{ marginTop: '10px' }} format="DD/MM/yyyy" value={endDate} label="End date" onChange={handleEndDateChange} disabled inputVariant="filled" margin="dense" />
                </Box>


                {/*<TextField onChange={e => setValues(x => ({ ...x, year: e.target.value }))} value={values.year} id="filled-basic" label="year" variant="filled" />*/}

                <Box display='flex' justifyContent='end' paddingTop='20px' paddingBottom='10px'>
                    <Button variant="contained" color="primary" onClick={() => {
                        createPayment()
                        refresh()
                    }
                    }>
                        Save
        </Button>

                    <Button style={{ marginLeft: '20px' }} variant="contained" color="primary" onClick={() => setStudentPayDialog(false)}>
                        Close
    </Button>
                </Box>
                <ListPayments studentsID={props.student.id} />

                {/* <SimpleList
                primaryText={record => studentPayment.amount + ' din'}
                secondaryText={record => moment(studentPayment.startDate).format('D/MM/YYYY') + ' - ' + moment(studentPayment.endDate).format('D/MM/YYYY')}
            />*/}
            </Box>
        </Dialog>
    </>)
}

export const NoteStudentDialog = (props) => {

    const [studentNoteDialog, setStudentNoteDialog] = React.useState(false)
    const { data } = useGetOne('students', props.student.id);
    const [value, setValue] = React.useState(null)
    const newNote = {
        note: value
    }
    const [update] = useUpdate('students', props.student.id, newNote, props.student);
    const refresh = useRefresh()

    React.useEffect(() => {
        data && setValue(data.note)
    }, [data])

    return (
        <>
            <Button variant="contained" color="primary" onClick={() => setStudentNoteDialog(true)}>
                Change note
                </Button>

            <Dialog open={studentNoteDialog} fullWidth>
                <Box style={{ margin: '10px' }}>
                    <TextField onChange={(e => setValue(e.target.value))} value={value} id="filled-basic" label="Student note" variant="filled" multiline fullWidth />
                    <Box display='flex' justifyContent='end' paddingTop='30px'>
                        <Button variant="contained" color="primary" onClick={() => update() & refresh()}>
                            Save
        </Button>
                        <Button style={{ marginLeft: '20px' }} variant="contained" color="primary" onClick={() => setStudentNoteDialog(false)}>
                            Close
    </Button>
                    </Box>
                </Box>
            </Dialog>

        </>
    );
}


export const StudentTrainingList = (props) => {

    const [studentTrainingDialog, setStudentTrainingDialog] = React.useState(false)
    const attendance = props.trainings ? [...props.trainings].reverse() : []

    return (
        <>
            <Button style={{ marginBottom: '30px' }} variant="contained" color="primary" onClick={() => setStudentTrainingDialog(true)}>
                Attendance
                </Button>
            <Dialog open={studentTrainingDialog} fullWidth>
                <Box style={{ margin: '10px' }}>
                    <TrainingTable fields={['Appointment', 'Location']}
                        data={attendance} />
                    <Button style={{ margin: '10px' }} variant="contained" color="primary" onClick={() => setStudentTrainingDialog(false)}>
                        Close
    </Button>
                </Box>
            </Dialog>
        </>
    );
}